import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export function ExperiencesView() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsx("main", {
      className: "flex w-full flex-col space-y-8"
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}